import { cloneDeep } from 'lodash'

export function sortSpecielties (specielties) {
  let especialidade = []
  specielties.map(item => {
    especialidade.push({  'nome': item.nome,
                          'id': item.sghs[0].codigoEspecialidade,
                          'sgh': item.sghs[0].codigoSgh  })
  });
  return especialidade.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
